import type { SlackGetChannelsResponse } from '@vy/api-definition';
import { SlackGetChannelsResponseSchema } from '@vy/api-definition';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { useActivatedIntegration } from '../use-activated-integration';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useSlackGetChannels(options?: CustomUseQueryOptions<SlackGetChannelsResponse>) {
  const isSlackActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.slack, { suspense: true });
  const isEnabledInOptions = withDefault(options?.enabled, true);
  const enabled = isEnabledInOptions && isSlackActivated;

  return useQuery(
    queryKeys.slackChannels(),
    async () => {
      return getSlackChannels();
    },
    { ...options, enabled },
  );
}

export function usePrefetchSlackChannels() {
  useSlackGetChannels({
    suspense: false,
  });
}

async function getSlackChannels() {
  try {
    const privateApi = getPrivateApi();
    const slackChannels = await privateApi.getSlackChannels();

    return SlackGetChannelsResponseSchema.parse(slackChannels);
  } catch (error) {
    console.error('Error fetching Slack channels:', error);

    return { channels: [] };
  }
} 